import React, { Component } from "react";
import ArticleComments from "./ArticleComments"


class FridayBlitz extends Component {


  render() {
    var spacerStyle = {
      marginTop: "100px",

    }
    var cardGalleryStyle = {
      padding:20,
      backgroundColor: "white"
    }

    var imgCenterStyle = {
    display: "block",
    margin:"0 auto",
    marginBottom: 15
    }

    var size13 = {
      fontSize: 13
    }

    var answerStyle = {
      fontSize:16
    }

    return (

      <div className="container Site-content" id="cardGalleryWrapper" style={spacerStyle}>
        <div id="cardGallery" style={cardGalleryStyle} className="rounded">

          <h1>Friday Night Blitz</h1>

          <p style={size13}>
            By: Psynight - March 24, 2018
          </p>

          <img src={"../ArticleImages/FridayBlitz.png"} style={imgCenterStyle} className="img-fluid" id="open" alt="open" />
          <p style={answerStyle}>
            Through the course of my card playing career, the comic / card shop was integral to the experience.  Whether it was a Magic pre-release tournament or just weekly gathering for a mini tournament that is where the sense of community began.
            It is time for us to start building up our community.  To that end I and by extension Nova Blitz HQ will be starting a Friday Night Blitz tournament series.
          </p>
          <p style={answerStyle}>
            The goal will be to have a reoccurring event where we can get together and play real players and start to see what a competitive tournament environment looks like.  Maybe just maybe we can even start to define a meta.
          </p>
          <p style={answerStyle}>
            You can sign up for the weekly tournament over on the Tournament tab.  You will need to submit a deck when checking in the day of the tournament.
            This is meant to be a fun gathering to play some real people.
            If we get to the point where the competition gets more serious or there are prizes involved
            I will work on making it so decks that are created for the tournament are hidden until after the tournament occurs.
            For now if you are really worried about it just add two or three when you create so people will not know which you are bringing.
           I have integrated the site with Challonge.
            When you register you will likely get a sign up email from Challonge.  It is not necessary for you to sign up on Challonge but you are welcome to.
          </p>
          <p><h4> Friday Night Blitz Rules </h4>
            <ul>
              <li>Swiss Tournament - 3 to 5 rounds</li>
              <li>One Deck per player, no changes or sidebar</li>
              <li>Best two out of three</li>
            </ul>
          </p>

          <p>
            Currently the site has the list of tournaments, the ability to sign up, check in, cancel sign up and cancel check in.  We will use the discord channel (link in the footer below) for communication during the tournamnet.  Match results will be submitted in the discord channel and I will add them into the tournamenet.
            As time goes on I will look into integrating that into the site as well.
          </p>
          <p style={answerStyle}>
            For now I plan on running these on Friday Night 9-11 EST.  If others are interested in hosting a tournament through the site reach out and we can coordinate that.
          </p>
          <p style={answerStyle}>
            I am very excited to see this take off.  See you Friday!
          </p>
        </div>
          <ArticleComments articleId={"5"} />
      </div>


    );
  }
}

export default FridayBlitz;



// WEBPACK FOOTER //
// ./src/Articles/FridayBlitz.js